import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { mergeClasses } from '@/utils/style';
interface DataBoxProps {
  title: string;
  text: string;
  variant?: 'primary' | 'light';
}
export function DataBox(t0) {
  const $ = _c(10);
  const {
    title,
    text,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "primary" : t1;
  let t2;
  if ($[0] !== variant) {
    t2 = mergeClasses("w-full max-w-[23rem] rounded-xl p-6 text-center md:rounded-4xl md:px-7 md:py-8", {
      "bg-blue-500 text-white": variant === "primary"
    }, {
      "bg-blue-100 text-blue-700": variant === "light"
    });
    $[0] = variant;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== title) {
    t3 = <p className="text-3xl font-semibold md:text-5xl">{title}</p>;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== text) {
    t4 = <p className="text-base font-semibold md:text-xl">{text}</p>;
    $[4] = text;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t5 = <div className={t2}>{t3}{t4}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}